module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [(_vm.ready) ? _c('div', [_c('ui-layout', {
    class: {
      'login-page': _vm.isLoginRoute()
    }
  }, [_c('ui-header'), _vm._v(" "), _c('ui-nav'), _vm._v(" "), _c('ui-content', [_c('breadcrumbs'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": _vm.transitionMode
    },
    on: {
      "enter": _vm.$defaultEnterTransition
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-js-snackbar mdl-snackbar mdl-snackbar-large",
    attrs: {
      "id": "snackbar-message"
    }
  }, [_c('div', {
    staticClass: "mdl-snackbar__text"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-snackbar__action",
    attrs: {
      "type": "button"
    }
  })])], 1)], 1), _vm._v(" "), _c('ui-dialog', {
    ref: "mainDialog"
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68b51c62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 274
// module chunks = 2